const PageHeader = ({ eyebrow, title, subtitle }) => (
  <header data-testid="page-header" className="px-6 md:px-14 pt-14 pb-8">
    {eyebrow && (
      <p className="eyebrow rise" style={{ color: "var(--p-burgundy)" }}>
        {eyebrow}
      </p>
    )}
    <h1
      className="mt-4 rise rise-1"
      style={{
        fontFamily: "Cormorant Garamond, serif",
        fontWeight: 500,
        fontSize: "clamp(2rem, 4.4vw, 3.4rem)",
        lineHeight: 1.05,
        color: "var(--p-black)",
        letterSpacing: "-0.01em",
      }}
    >
      {title}
    </h1>
    {subtitle && (
      <p
        className="mt-4 max-w-2xl rise rise-2"
        style={{
          fontFamily: "Cormorant Garamond, serif",
          color: "var(--p-brown)",
          fontSize: "1.15rem",
          lineHeight: 1.6,
        }}
      >
        {subtitle}
      </p>
    )}
    <div className="rule-gold mt-10" />
  </header>
);

export default PageHeader;
